// extracted by mini-css-extract-plugin
export default {"wrap":"ir-z","fullWidth":"jr-z","items":"kr-z","featureCss":"lr-z","disabled":"mr-z","imgCss":"nr-z"};